import React from "react";
import ErrorStore from "./ErrorStore";
import MainStore from "./MainStore";
import UserStore from "./UserStore";
import StyleStore from "./StyleStore";
import MarketplaceStore from "./MarketplaceStore";
import CatalogueStore from "./CatalogueStore";
import ReportStore from "./reportStore";
import RatingStore from "./RatingStore";
import { RequestsStore } from "./requestsStore";
import { LearningGraphStore } from "./LearningGraphStore";

const isServer = typeof window === "undefined";
let clientSideStores;

export function getStores() {
  var errorStore = new ErrorStore();
  if (isServer) {
    return {
      errorStore: errorStore,
      mainStore: new MainStore({ errStore: errorStore }),
    };
  }
  if (!clientSideStores) {
    clientSideStores = {
      errorStore: errorStore,
      mainStore: new MainStore({ errStore: errorStore }),
      userStore: new UserStore({ errStore: errorStore }),
      styleStore: new StyleStore({ errStore: errorStore }),
      catalogueStore: new CatalogueStore({ errStore: errorStore }),
      marketplaceStore: new MarketplaceStore({ errStore: errorStore }),
      reportStore: new ReportStore({ errStore: errorStore }),
      ratingStore: new RatingStore({ errStore: errorStore }),
      requestsStore: new RequestsStore(),
      learningGraphStore: new LearningGraphStore(),
    };
  }

  return clientSideStores;
}

const StoreContext = React.createContext();

export function StoreProvider(props) {
  return (
    <StoreContext.Provider value={props.value}>
      {props.children}
    </StoreContext.Provider>
  );
}

export function useMobxStores() {
  return React.useContext(StoreContext);
}
